import {Component, Input, OnInit} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-map-secondary-button',
    templateUrl: './map-secondary-button.component.html',
    styleUrls: ['./map-secondary-button.component.scss'],
    imports: [
      TranslatePipe
    ],
    standalone: true
})

export class MapSecondaryButtonComponent implements OnInit {
  @Input() label: string = '';

  constructor() {
  }

  ngOnInit() {
  }

}
